import { Marker } from "@react-google-maps/api";
import { getMarkerSeverityInMenu } from "./enums";
import { getMarkerIcon } from "./icons/MarkerIconLibary";
import { ISystemData } from "./interfaces";
import clusterIconGenerator from "./icons/ClusterIconGenerator";

export const MapMarkers = ({
  clusterer,
  systems,
  categorySelected,
  onClick,
}) => {
  return systems
    .filter((x) =>
      getMarkerSeverityInMenu(categorySelected).includes(x.status.statusType)
    )
    .map((markerData) => {
      if (
        typeof markerData.position.lat !== "number" ||
        typeof markerData.position.lng !== "number"
      )
        return null;

      const mapMarker = (
        <Marker
          key={
            markerData.status.needRerender
              ? markerData.id + Math.random()
              : markerData.id
          }
          title={markerData.name}
          position={{
            lat: markerData.position.lat,
            lng: markerData.position.lng,
          }}
          icon={getMarkerIcon(markerData.status.statusType, markerData.type)}
          onClick={() => onClick(markerData)}
          clusterer={clusterer}
          onLoad={(marker) => {
            marker.set("markerData", markerData);
            clusterer.redraw();
          }}
        />
      );

      if (markerData.status.needRerender)
        markerData.status.needRerender = false;

      return mapMarker;
    });
};

// Check if System is centered
export const isSystemCentered = (system: ISystemData, mapLat, mapLng) => {
  if (!mapLat || !mapLng || !system.position.lat || !system.position.lng)
    return false;
  const minNumberOfDecimals = 6;
  const cutDecimalsAmount = 2;
  const markerLatDecimalAmount = Math.max(
    system.position.lat.toString().split(".")[1].length,
    minNumberOfDecimals
  );
  const markerLngDecimalAmount = Math.max(
    system.position.lng.toString().split(".")[1].length,
    minNumberOfDecimals
  );

  // Find the center lat and lng, rounded to the same decimals as the marker, minus numberOfCutDecimals decimal
  const centerLat =
    Math.round(
      mapLat * Math.pow(10, markerLatDecimalAmount - cutDecimalsAmount)
    ) / Math.pow(10, markerLatDecimalAmount - cutDecimalsAmount);
  const centerLng =
    Math.round(
      mapLng * Math.pow(10, markerLngDecimalAmount - cutDecimalsAmount)
    ) / Math.pow(10, markerLngDecimalAmount - cutDecimalsAmount);
  const markerLat =
    Math.round(
      system.position.lat *
        Math.pow(10, markerLatDecimalAmount - cutDecimalsAmount)
    ) / Math.pow(10, markerLatDecimalAmount - cutDecimalsAmount);
  const markerLng =
    Math.round(
      system.position.lng *
        Math.pow(10, markerLngDecimalAmount - cutDecimalsAmount)
    ) / Math.pow(10, markerLngDecimalAmount - cutDecimalsAmount);

  // console.log('Center', 'Lat', centerLat)
  // console.log('Marker', 'Lat', markerLat)
  // console.log('Center', 'Lng', centerLng)
  // console.log('Marker', 'Lng', markerLng)

  const matchingLat = centerLat === markerLat;
  const matchingLng = centerLng === markerLng;

  return matchingLat && matchingLng;
};
